import { render } from "./ViewSiteDetailModal.vue?vue&type=template&id=6a2372e4&ts=true"
import script from "./ViewSiteDetailModal.vue?vue&type=script&lang=ts"
export * from "./ViewSiteDetailModal.vue?vue&type=script&lang=ts"

import "./ViewSiteDetailModal.vue?vue&type=style&index=0&id=6a2372e4&lang=scss"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__